/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Scalars } from '__generated__/graphql-types';

import { LONG_MONTH_YEAR_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import { BellIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

type Props = { launchedAt: Scalars['DateTime'] };
const styles = {
  itemTitle: (theme: Theme) => css`
    padding: ${theme.spacing(8, 0)};
  `,
  icon: css`
    display: block;
  `,
};

const RecentlyUpdatedDetailItem = ({ launchedAt }: Props) => {
  return (
    <React.Fragment>
      <BellIcon size="large" css={styles.icon} />
      <Typography2 variant="subtitleMedium" css={styles.itemTitle} component="div">
        {_t('Recently updated!')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {formatDateTimeDisplay(launchedAt, LONG_MONTH_YEAR_DISPLAY)}
      </Typography2>
    </React.Fragment>
  );
};

export default RecentlyUpdatedDetailItem;
